export class GetUsers {
  public static readonly type = "[Users] Get Users";
  public constructor() {}
}
